/* eslint-disable @typescript-eslint/ban-ts-comment */
import { AxiosResponse } from "axios";
import { coreAccountUrls } from "../../url";
import { taxGuruAxios } from "../../axios";
import {
    CoreUser,
    CoreUserPasswordChangeRequest,
    CoreUserRequest,
    CoreUserResults,
    Filter,
    SimpleUserInfoResponse,
} from "@mm-products/java-multima-framework";

export const listAccounts = (filter: Filter, signal?: AbortSignal, toastId?: string): Promise<AxiosResponse<CoreUserResults>> => {
    return taxGuruAxios.post(coreAccountUrls.filter, filter, {
        signal,
        // @ts-ignore
        toastId,
    });
};

export const createAccount = (coreUser: CoreUserRequest, toastId?: string): Promise<AxiosResponse<CoreUser>> => {
    return taxGuruAxios.post(coreAccountUrls.create, coreUser, {
        // @ts-ignore
        toastId,
    });
};

export const changePassword = (accountId: string, request: CoreUserPasswordChangeRequest, toastId?: string): Promise<AxiosResponse<void>> => {
    return taxGuruAxios.put(coreAccountUrls.changePassword(encodeURIComponent(accountId)), request, {
        // @ts-ignore
        toastId,
    });
};

export const deleteAccount = (accountId: string, toastId?: string): Promise<AxiosResponse<CoreUser>> => {
    return taxGuruAxios.delete(coreAccountUrls.delete(encodeURIComponent(accountId)), {
        // @ts-ignore
        toastId,
    });
};

export const enableAccount = (accountId: string, toastId?: string): Promise<AxiosResponse<void>> => {
    return taxGuruAxios.post(coreAccountUrls.enable(encodeURIComponent(accountId)), undefined, {
        // @ts-ignore
        toastId,
    });
};

export const disableAccount = (accountId: string, toastId?: string): Promise<AxiosResponse<void>> => {
    return taxGuruAxios.post(coreAccountUrls.disable(encodeURIComponent(accountId)), undefined, {
        // @ts-ignore
        toastId,
    });
};

export const updateAccount = (accountId: string, account: CoreUserRequest, toastId?: string): Promise<AxiosResponse<CoreUser>> => {
    return taxGuruAxios.put(coreAccountUrls.update(encodeURIComponent(accountId)), account, {
        // @ts-ignore
        toastId,
    });
};

export const getAccount = (accountId: string, toastId?: string, signal?: AbortSignal, noErrorToast?: boolean): Promise<CoreUser> => {
    return taxGuruAxios
        .get(coreAccountUrls.get(encodeURIComponent(accountId)), {
            // @ts-ignore
            toastId,
            noErrorToast,
            signal,
        })
        .then((res) => res.data);
};

export const getCurrentUserSimpleInfo = (): Promise<AxiosResponse<SimpleUserInfoResponse>> => {
    // @ts-ignore
    return taxGuruAxios.get(coreAccountUrls.simpleInfo, { noErrorToast: true });
};

export const activateTemporaryPassword = (accountId: string, toastId?: string): Promise<AxiosResponse<void>> => {
    return taxGuruAxios.post(coreAccountUrls.markTemporary(encodeURIComponent(accountId)), undefined, {
        // @ts-ignore
        toastId,
    });
};

export const deactivateTemporaryPassword = (accountId: string, toastId?: string): Promise<AxiosResponse<void>> => {
    return taxGuruAxios.post(coreAccountUrls.unmarkTemporary(encodeURIComponent(accountId)), undefined, {
        // @ts-ignore
        toastId,
    });
};
